// extracted by mini-css-extract-plugin
export default {"container":"home_container__pD8t1"};